module.exports = __webpack_public_path__ + "img/kilpailu.050a4a94.jpg";